/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Sivua ei löydy",
  "ComingSoon": "Tulossa pian",
  "YesanPersonalFinance": "Yesan, henkilökohtainen talous",
  "Yesan": "Yesan",
  "PersonalFinance": "Henkilökohtainen talous",
  "YesanDownload": "Yesan Lataa",
  "ThisWebsiteUsesCookies": "Käytämme evästeitä kerätäksemme ja analysoidaksemme tietoja sivustomme suorituskyvystä ja käytöstä sekä tarjotaksemme sosiaalisen median ominaisuuksia. Jatkamalla hyväksyt, että",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Tule taloudellisesti vapaaksi",
  "inStepsAndActions": "8 askeleessa ja 3 toimenpiteessä.",
  "TrackPlanAnalyze": "Seuraa. Suunnittele. Analysoi.",
  "FTrack": "1. Seuraa",
  "FPlan": "2. Plan",
  "FAnalyze": "3. Analysoi",
  "Features": "Ominaisuudet",
  "FeaturesSubHeading": "Puhdas aloittelija, joka on jo taloudellisesti lukutaitoinen, tämä on sovellus, jota tarvitset tullaksesi taloudellisesti vapaaksi.",
  "ManageAccounts": "Hallitse tilejä",
  "CashLiquidFixedAssetsLiabilities": "Käteisvarat, likvidit, kiinteät varat ja velat.",
  "TrackTransactions": "Seuraa tapahtumia",
  "IncomesExpensesTransferInvestments": "Tulot, menot, siirrot, sijoitukset.",
  "ImportExport": "Tuo / vie",
  "YourDataAlwaysAccessible": "Tietosi ovat aina saatavilla.",
  "PlanYourFreedom": "Suunnittele vapautesi",
  "StepsAwayFromFI": "8 askeleen päässä taloudellisesta riippumattomuudesta.",
  "BudgetsAndGoals": "Budjetit ja tavoitteet",
  "CheckYourProgressAndAchieve": "Tarkista edistyksesi ja saavuta taloudelliset tavoitteesi.",
  "DashboardAndAnalytics": "Kojelauta ja analytiikka",
  "ReviewLearnOptimizeWith": "Tarkastele, opi ja optimoi kaavioiden, oivallusten ja työkalujen avulla.",
  "Security": "Turvallisuus",
  "MilitaryGradeEncryption": "Sotilasluokan salaus, biometriatuki, tiedot tallennetaan laitteisiisi.",
  "OfflineMode": "Offline-tila",
  "YourDataAlwaysAccessibleAndModif": "Tietosi ovat aina saatavilla ja muokattavissa.",
  "Track": "Seuraa",
  "Income": "Tulot",
  "Expense": "Kulut",
  "Transfer": "Siirrä",
  "transactionsAndManageAccounts": "tapahtumia ja hallinnoi erilaisia tilejä:",
  "checkings": ".",
  "savings": "Säästöt",
  "realEstate": "Kiinteistöt",
  "stocks": "Osakemarkkinat",
  "bonds": "Joukkovelkakirjat",
  "crypto": "Krypto",
  "notes": "Setelit, käteinen Lompakko",
  "envelopes": "Kirjekuoret",
  "privateEquity": "Yksityinen pääoma",
  "metal": "Metalli",
  "retirement": "Eläkkeelle siirtyminen",
  "lifeInsurance": "Henkivakuutus",
  "intellectualProperty": "Immateriaalioikeudet",
  "otherLiquidAsset": "Muut likvidit varat",
  "otherFixedAsset": "Muu käyttöomaisuus",
  "mortgage": "Kiinnitys",
  "loan": "Kulutuslaina",
  "creditCard": "Luottokortti",
  "otherLiability": "Muu velka",
  "AccountsManagement": "Tilien hoito",
  "MultipleAccountsTypesAndGrouping": "Useat tilityypit ja ryhmittely",
  "LinkAccounts": "Linkitä tilit laitoksistasi (käytettävissä vain tietyissä maissa).",
  "SmartAccounts": "Älykkäät tilit",
  "AddEditDeleteTransactions": "Tapahtumien lisääminen / muokkaaminen / poistaminen",
  "TickVerifiedTransactions": "Tarkistettujen tapahtumien merkitseminen rastilla",
  "CategorizeTransactions": "Luokittele tapahtumat",
  "TagTransactions": "Merkitse tapahtumat",
  "TrackKakeiboType": "Seuraa Kakeibo-tyyppiä",
  "TrackInvestments": "Seuraa investointeja (käytettävissä vain tietyissä maissa)",
  "ImportFromCSVFile": "Tuo tapahtumat kokonaisuudessaan tai asteittain CSV-tiedostosta.",
  "ExportToCSVFile": "Siirtojen vienti CSV-tiedostoon",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 askelta kohti taloudellista riippumattomuutta -suunnitelma, yksityiskohtainen budjetointi, saavutat taloudelliset tavoitteesi nopeammin.",
  "levelsTowardsFI": "8 tasoa kohti taloudellista riippumattomuutta",
  "EstablishBudgetsPer": "Budjettien laatiminen per",
  "account": "tili",
  "accountType": "tilityyppi",
  "KakeiboType": "Kakeibo-tyyppi",
  "category": "luokka",
  "tag": "tag",
  "label": "etiketti",
  "TrackBudgetsPerFrequency": "Seuraa budjetit taajuutta kohti",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Luo tavoitteita menoista, saldosta, kassavirrasta, toimista",
  "TrackGoalsProgress": "Seuraa tavoitteiden edistymistä",
  "ReviewLearnOptimizeWithReportsCharts": "Tarkastele, opi ja optimoi raporttien, kaavioiden, trendien, oivallusten ja työkalujen avulla.",
  "Dashboard": "Dashboard",
  "FSNetWorth": "Tilinpäätös: Nettovarallisuus",
  "FSPnL": "Taloudelliset lausunnot: Tuloslaskelma: Tuloslaskelma / Voitto ja tappio",
  "FSBalanceSheetAssetsLiabilities": "Tilinpäätös: Tase, varat, velat",
  "FSCashFlow": "Tilinpäätös: Rahavirtalaskelma, veloitus, hyvitys, virtaukset.",
  "FSFlows": "Tilinpäätös: Virrat",
  "FSRatios": "Tilinpäätös: Suhdeluvut",
  "TrendsMonthEnd": "Kuukauden lopun trendit: Tulot ja menot, kassavirta",
  "TrendsPerformance": "Suorituskyvyn suuntaukset: YoY, MoM, WoW",
  "IncomeTrendsPer": "Tulojen kehitys per",
  "SpendingTrendsPer": "Menojen kehitys per",
  "RecurringItemsIE": "Toistuvat erät: Tulot ja menot",
  "DebtProgressTrends": "Velan edistymisen trendit",
  "KakeiboMTDReviewTrends": "Kakeibo: Kakeakeibo: MTD-tarkastelu, viime kuukausi, trendit",
  "FIWCLE": "Taloudellinen riippumattomuus: Kakeibake: Seinäkaavio, kulut elämänenergian mukaan: Wall Chart, Expenses by Life Energy",
  "DebtPaydownSnowballAvalanche": "Velkojen lyhentäminen: Lumipallo, lumivyöry",
  "FullyCustomizableAnalyticsRange": "Täysin muokattavissa oleva analytiikan aikaväli",
  "ContactUs": "Ota yhteyttä",
  "Privacy": "Yksityisyys",
  "Terms": "Termit",
  "About": "Tietoja",
  "IAgreeToThe": "Hyväksyn",
  "AndThe": "ja",
  "PrivacyPolicy": "Tietosuojakäytäntöä",
  "TermsOfUse": "Käyttöehdot",

  "DigitalSoftwareExperienceTagline": "Digitaalinen ohjelmistokokemus nykymaailmaa varten",
  "DigitalExperience": "Digitaalinen kokemus",
  "SoftwareForTheModernWorld": "Ohjelmistot nykymaailmaa varten",
  "MobileApplications": "Mobiilisovellukset",
  "forConnectedAndOfflineHumans": "verkottuneille ja offline-ihmisille",
  "CloudSaaS": "Pilvi-SaaS",
  "ResponsiveAndWebServices": "Responsiiviset ja verkkopalvelut",
  "PersonalFinanceServices": "Henkilökohtaiset rahoituspalvelut",
  "YS_p1": "Yesan on dynaaminen ohjelmistoyritys, joka on erikoistunut kuluttajille räätälöityjen huippuluokan mobiilisovellusten kehittämiseen. Yesan tuntee hyvin nykypäivän teknisesti perehtyneiden käyttäjien kehittyvät tarpeet ja mieltymykset, ja sen tavoitteena on luoda intuitiivisia, houkuttelevia ja ominaisuuksiltaan monipuolisia mobiilikokemuksia, jotka rikastuttavat käyttäjien elämää.",
  "YS_p2": "Yesanin mission ytimessä on väsymätön sitoutuminen innovointiin ja luovuuteen, ja jokainen tuote on huolellisesti suunniteltu saumattomien toimintojen ja poikkeuksellisen käyttäjäkokemuksen tarjoamiseksi.",
  "PersonalFinanceApplication": "Henkilökohtainen rahoitussovellus",
  "YPF_p1": "Yesan, Personal Finance on huippuluokan henkilökohtaisen talouden mobiilisovellus, joka on suunniteltu antamaan käyttäjille kattavat taloushallintotyökalut kätevästi käden ulottuvilla. Yesan, Personal Finance tarjoaa tyylikkään ja intuitiivisen käyttöliittymän avulla kokonaisvaltaisen lähestymistavan talouden hallintaan, joka sopii kaiken tasoisille käyttäjille.",
  "YPF_p2": "Tärkeimpiä ominaisuuksia ovat budjetin seuranta, menojen luokittelu ja reaaliaikainen tapahtumien seuranta, joiden avulla käyttäjät voivat saada tietoa kulutustottumuksistaan vaivattomasti. Sovellus tarjoaa myös mukautettavia budjetointivaihtoehtoja, joiden avulla käyttäjät voivat asettaa taloudellisia tavoitteita ja seurata edistymistään ajan mittaan.",
  "YPF_p3": "Lisäksi Yesan, Personal Finance asettaa turvallisuuden etusijalle ja käyttää huippuluokan salausprotokollia käyttäjien arkaluontoisten taloudellisten tietojen suojaamiseksi. Pankkitason turvatoimien ansiosta käyttäjät voivat luottavaisesti yhdistää tilinsä ja synkronoida tapahtumia vaarantamatta yksityisyyttä.",
  "YPF_p4": "Yesan, Personal Finance menee perusbudjetointia pidemmälle tarjoamalla oivaltavia analyysejä ja henkilökohtaisia suosituksia taloudellisten päätösten optimoimiseksi. Olipa kyse sitten mahdollisten säästömahdollisuuksien tunnistamisesta, sijoitussalkkujen seurannasta tai velkojen takaisinmaksustrategioiden hallinnasta, sovellus tarjoaa räätälöityjä näkemyksiä, jotka auttavat käyttäjiä saavuttamaan taloudelliset tavoitteensa.",
  "Discover": "Tutustu",
  "Firstname": "Etunimi",
  "Lastname": "Sukunimi",
  "Company":"Yritys",
  "Subject": "Aihe",
  "Email": "Sähköposti",
  "Message": "Viesti",
  "ThankYouForContactingUs": "Kiitos yhteydenotosta",
  "ValidFirstnameRequired": "Kelvollinen etunimi vaaditaan.",
  "ValidLastnameRequired": "Kelvollinen sukunimi vaaditaan.",
  "ValidEmailAddressRequired": "Syötä voimassa oleva sähköpostiosoite.",
  "ValidSubjectRequired": "Valitse kelvollinen aihe.",
  "ValidMessageRequired": "Kirjoita kelvollinen viesti.",
  "UnableToSendTheFormPleaseRetryLater": "Lomaketta ei pystytä lähettämään, yritä myöhemmin uudelleen.",
  "Information": "Tietoja",
  "Sales":"Myynti",
  "Support": "Tuki",
  "Press": "Paina",
  "Partnership": "Kumppanuus",
  "Other": "Muut",
  "Blog":"Blogi",

  "Accept":"Hyväksy",
  "Decline":"Hylkää",

  "WorklogCalendar":"Työpäiväkirja Kalenteri Jiraa varten",

  "DirectlyAccessibleInProjectApps":"Suoraan käytettävissä projektisovelluksissa",
  "VisualizeWhereYouSpentYourTime":"Visualisoi, mihin käytit aikaasi",
  "AllYourWorklogsInACalendar":"Kaikki työpäiväkirjasi kalenterissa",
  "MonthSummary":"Kuukauden yhteenveto",
  "CheckIfYouForgotToLogTime":"Tarkista, oletko unohtanut kirjata aikaa.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Pääset suoraan asioihin ja päivität aikaa",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Napsauta työpäiväkirjan kohdetta päästäksesi suoraan asioihin ja muokataksesi seurattua aikaasi",
  "AlsoAvailableInDarkMode":"Käytettävissä myös pimeässä tilassa",
  "DirectlyLogWorkOnTheCalendarVisually":"kirjaa työt suoraan kalenteriin visuaalisesti",
  "ClickOnTheCalendarToCreateNewWorklog":"Luo uusi työpäiväkirja napsauttamalla kalenteria",

  "AppsForAtlassian":"Atlassian-sovellukset",
  "YCL_p1":"Visualisoi kaikki työpäiväkirjasi kalenterissa kuukauden, viikon, työviikon ja päivän näkymillä.",
  "YCL_p2":"Kirjaa työt suoraan kalenterista visuaalisesti valitsemalla aikaväli.",
  "YCL_p3":"Tunnista, jos olet unohtanut seurata aikaa työaikakirjanpitoon.",
  "YCL_p4":"Saatavana omalla kielelläsi: Englanti (UK), Englanti (US), Kiina (yksinkertaistettu), Kiina (perinteinen), Tšekki, Tanska, Hollanti, Viro, Suomi, Ranska, Saksa, Unkari, Islanti, Italia, Japani, Korea, Norja, Puola, Portugali (Brasilia), Portugali (Portugali), Venäjä, Espanja, Ruotsi, Turkki.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Financial Portfolio for Jira",
  "BringRealFinancialPortfolio":"Tuo aito taloudellinen salkunhallinta Jiraan. Seuraa budjetteja, investointeja (CapEx) ja käyttökustannuksia (OpEx) sekä projektikustannuksia yhdestä paikasta.",
  "YFPAboutQ":"Kuinka paljon Jira-projektimme todella maksavat meille?",
  "YFPAbout":"Financial Portfolio for Jira\nTalousjohtajat ja PMO:t kamppailevat vastatessaan yksinkertaiseen kysymykseen:\nKuinka paljon Jira-projektimme todella maksavat meille?\nJira seuraa työtä.\nTalousosasto seuraa budjetteja.\nTämä sovellus yhdistää vihdoin nämä kaksi.\n\nFinancial Portfolio muuttaa Jiran kevyeksi PPM- ja taloussuunnittelualustaksi — ilman kalliita yritystyökaluja.",
  "YFPPorfolioQ":"Portfolion budjetit ja seuranta",
  "YFPPorfolioP":"Luo portfoliot useille Jira-projekteille ja määritä: budjetin määrä, valuutta, ajanjakso, mukana olevat projektit ja tiimit. Seuraa todellisia kustannuksia automaattisesti, kun työ etenee Jirassa.",
  "YFPPorfolioListQ":"Portfoliot",
  "YFPPorfolioListP":"Luo taloudellisia portfolioita, jotka yhdistävät useita Jira-projekteja, ja näe välittömästi: budjetti vs. todelliset kustannukset, projektin kulutusaste reaaliajassa, CapEx- ja OpEx-erittely, kustannukset ongelmaa ja projektia kohti sekä viedyt taloudelliset raportit. Kaikki perustuu suoraan Jiran työpäiväkirjoihin.",
  "CostQ":"Automaattinen kustannuslaskenta",
  "CostP":"Muuta ajanseuranta todellisiksi taloudellisiksi tiedoiksi. Sovellus: Lukee Jira-työlokit, soveltaa tuntitaksoja, laskee todelliset projektikustannukset päivittäin. Ei taulukoita. Ei manuaalista työtä.",
  "RatesQ":"Hinnat",
  "RatesP":"Aseta tuntitaksa projektikohtaisesti, tiimikohtaisesti tai yleisesti",
  "ReportQ":"CSV-talousraportointi",
  "ReportP":"Vie salkun taloudelliset tiedot sekunneissa. Sopii erinomaisesti: taloushallinnolle, talousjohtajan raportoinnille, budjetin suunnittelulle, tilintarkastuksen tueksi",
  "SettingsQ":"CapEx- ja OpEx-luokittelu",
  "SettingsP":"Tukee kirjanpito- ja tilintarkastusvaatimuksia. Luokittele työ: aktivoitavaksi kehitykseksi (CapEx) ja operatiiviseksi työksi (OpEx). Luo viedyt raportit, jotka ovat valmiita taloushallinnolle."
};

export const documents = {
};
